<script>
import { mapState, mapActions } from 'pinia';

import { useUserStore } from '../../../store/useUserStore.js';

export default {
  name: 'CpLobbyFlowDialog',
  components: {
    CpMissingInfoForm: require('../lobbying/MissingInfoForm').default,
    CpLobbyFormDialog: require('./LobbyFormDialog').default,
    CpVerifyEmailDialog: require('./VerifyEmail').default,
    CpDialogAuthForm: require('../auth-form/dialog-auth-form').default,
  },
  props: {
    showDialog: { type: Boolean, default: false },
    type: { type: String, default: 'none' },
    commentToRep: { type: String, default: null },
    newsArticle: { type: Object, default: null },
    politician: { type: Object, default: null },
    modalFeed: { type: Boolean, default: false },
    refProp: { type: Object, default: null },
    callback: { type: Function, default: () => {} },
    shareMessageInComments: { type: Boolean, default: false },
    originalPostType: { type: String, default: null },
    originalPostId: { type: [Number, String], default: null },
  },
  data() {
    return {
      addressUpdated: false,
      showAuthModal: false,
      showVerifyEmailModal: false,
      isInitialized: false,
    };
  },
  async mounted() {
    await this.handleVerifyEmail();
    this.isInitialized = true;
  },
  computed: {
    ...mapState(useUserStore, ['userProfileData', 'isUserLogin']),
    isAddressCompleted() {
      return this.userProfileData?.address_state && this.userProfileData?.address_zip;
    },
  },
  methods: {
    async handleVerifyEmail() {
      if (this.isUserLogin && !this.userProfileData?.email_verified) {
        await this.getUserProfile();
      }
      if (!this.userProfileData?.email_verified) {
        this.showVerifyEmailModal = true;
      } else if (!this.isAddressCompleted) {
        this.addressUpdated = false;
      }
    },
    handleVerifyEmailModal() {
      this.showVerifyEmailModal = !this.showVerifyEmailModal;
      this.handleDialog();
    },
    handleDialog() {
      this.$emit('close');
      this.addressUpdated = false;
    },
    handleAddressUpdated() {
      this.addressUpdated = true;
    },
    ...mapActions(useUserStore, ['getUserProfile']),
  },
  watch: {
    showDialog(newVal) {
      if (!newVal) {
        this.addressUpdated = false;
      }
    },
  },
};
</script>

<template>
  <div v-if="showDialog && isInitialized">
    <CpDialogAuthForm v-if="!isUserLogin" :handleCloseButton="handleDialog" />

    <CpVerifyEmailDialog 
      v-else-if="isUserLogin && !userProfileData?.email_verified" 
      :handleDialog="handleVerifyEmailModal" 
    />

    <CpMissingInfoForm 
      v-else-if="isUserLogin && userProfileData?.email_verified && !isAddressCompleted && !addressUpdated" 
      :handleDialog="handleDialog" 
      @address-updated="handleAddressUpdated" 
    />

    <CpLobbyFormDialog
      v-else-if="isUserLogin && userProfileData?.email_verified && isAddressCompleted"
      :showDialog="showDialog"
      :type="type"
      :commentToRep="commentToRep"
      :newsArticle="newsArticle"
      :politician="politician"
      :modalFeed="modalFeed"
      :refProp="refProp"
      :callback="callback"
      :shareMessageInComments="shareMessageInComments"
      :originalPostType="originalPostType"
      :originalPostId="originalPostId"
      @close="handleDialog"
    />
  </div>
</template>
